export * from './angularx-qrcode.component';
//# sourceMappingURL=index.js.map